import { Component, h, Prop, Host } from '@stencil/core';
import { AccordionNode } from '../utils';
import ArrowDown from '../../svg-elements/arrow-down';

@Component({
  tag: 'rtr-accordion-template-config',
  styleUrl: 'style-config.sass',
  shadow: false,
})
export class RtrAccordionTemplateConfig {
  @Prop() nodesObject: AccordionNode;
  @Prop() nodeIndex: number;
  @Prop() openedIndex: number;
  @Prop() onOpenIndex: (index: number) => void;

  handleClick = () => {
    if (!this.nodesObject.disableExpanded) {
      this.onOpenIndex(this.nodeIndex);
    }
  };

  render() {
    const currentOpened = this.nodeIndex === this.openedIndex;
    const hideRow = currentOpened && this.nodesObject.hideCollapsedOnExpanded;

    return (
      <Host class={{ RACollapsibleOpened: currentOpened }}>
        <div class={{ RACollapsibleRow: true, RACollapsibleRowHidden: hideRow, RACollapsibleDisableExpanded: this.nodesObject.disableExpanded }} onClick={this.handleClick}>
          {this.nodesObject.collapsed}
          {!this.nodesObject.disableExpanded && (
            <div class="RAArrowWrapper">
              <div class="RAArrow">
                <ArrowDown />
              </div>
            </div>
          )}
        </div>
        <div class={{ RAContent: true, RAContentExpanded: currentOpened }}>{this.nodesObject.expanded}</div>
      </Host>
    );
  }
}
